import ContactInformationFrom from './ContactInformationForm'
import './ContactInformationForm.sass'

export default ContactInformationFrom
